import { IApp } from './appInterface';

class AppRef {
  private static appInstance?: IApp;

  static setApp(app: IApp): void {
    this.appInstance = app;
  }

  static get current(): IApp {
    /* HACK: type safetiness is violated to reduce null checks.
     * Usage of "shared" assumes `AppRef` initialization before app mount,
     * so this code is safe.
     */
    return (this.appInstance ?? {}) as IApp;
  }
}

export { AppRef };
